import { wrap } from 'svelte-spa-router/wrap'
import { needLogin, isLogin } from './auth'

import LoginView from './users/view.login.svelte'
import ShipmentsView from './shipments/view.shipments.svelte'
import UsersView from './users/view.users.svelte'
import NotificationsView from './notifications/view.notifications.svelte'
import PickupsView from './pickups/view.pickups.svelte'
import AccountsView from './accounts/view.accounts.svelte'
import CreditsView from './credits/view.credits.svelte'
import InvoicesView from './facturama/view.invoices.all.svelte'
import ChargesView from './charges/view.charges.svelte'
import OverweightsView from './charges/view.overweights.svelte'
import RefundsView from './refunds/view.refunds.svelte'
import WalletsView from './wallets/view.wallets.svelte'
import ShopifyView from './shopify/view.shopifys.svelte'
import NoticesView from './notices/view.notices.svelte'
import TipsView from './tips/view.tips.svelte'
import ProvidersView from './providers/view.providers.svelte'
import PricesView from './prices/view.prices.svelte'
import GraphicsView from './graphics/view.graphics.svelte'
import QuotationsView from './quotations/view.quotations.svelte'
import ErrorsView from './errors/view.errors.svelte'
import StpView from './stp/view.ordenes.svelte'
import NotFoundView from './$layouts/notfound.layout.svelte'

const routes = {

    '/': wrap({
        component: LoginView,
        conditions: [needLogin]
    }),

    '/graphics': wrap({
        component: GraphicsView,
        conditions: [isLogin]
    }),

    '/quotations': wrap({
        component: QuotationsView,
        conditions: [isLogin]
    }),

    '/shipments': wrap({
        component: ShipmentsView,
        conditions: [isLogin]
    }),

    '/users': wrap({
        component: UsersView,
        conditions: [isLogin]
    }),

    '/notifications': wrap({
        component: NotificationsView,
        conditions: [isLogin]
    }),

    '/pickups': wrap({
        component: PickupsView,
        conditions: [isLogin]
    }),

    '/wallets': wrap({
        component: WalletsView,
        conditions: [isLogin]
    }),

    '/accounts': wrap({
        component: AccountsView,
        conditions: [isLogin]
    }),

    '/credits': wrap({
        component: CreditsView,
        conditions: [isLogin]
    }),

    '/invoices': wrap({
        component: InvoicesView,
        conditions: [isLogin]
    }),

    '/charges': wrap({
        component: ChargesView,
        conditions: [isLogin]
    }),

    '/overweights': wrap({
        component: OverweightsView,
        conditions: [isLogin]
    }),

    '/refunds': wrap({
        component: RefundsView,
        conditions: [isLogin]
    }),

    '/shopify': wrap({
        component: ShopifyView,
        conditions: [isLogin]
    }),

    '/notices': wrap({
        component: NoticesView,
        conditions: [isLogin]
    }),

    '/tips': wrap({
        component: TipsView,
        conditions: [isLogin]
    }),

    '/providers': wrap({
        component: ProvidersView,
        conditions: [isLogin]
    }),

    '/prices': wrap({
        component: PricesView,
        conditions: [isLogin]
    }),

    '/errors': wrap({
        component: ErrorsView,
        conditions: [isLogin]
    }),

    '/stp': wrap({
        component: StpView,
        conditions: [isLogin]
    }),

    '*': wrap({
        component: NotFoundView
    })
}

export { routes }
